import React, {useState, useEffect} from 'react';
import {Link, Route, useParams} from 'react-router-dom';
import axios from 'axios';

function ExhibitionUpcomingList (){
    const [exhibitions, setExhibitions] = useState([]);
    const [exhibitionsNumber, setExhibitionsNumber] = useState();
    const [tagRecommendation, setTagRecoomendation] = useState(false);
    const [tagFreeAdmission, setTagFreeAdmission] = useState(false);
    const [tagContemporaryArt, setTagContemporaryArt] = useState(false);
    const [tagModernArt, setTagModernArt] = useState(false);
    const [tagClassicArt, setTagClassicArt] = useState(false);
    const [tagAncientArt, setTagAncientArt] = useState(false);
    const [tagAppliedFineArts, setTagAppliedFineArts] = useState(false);
    const [tagPhotograph, setTagPhotograph] = useState(false);
    const [tagAll, setTagAll] = useState(false);
    const {tag} = useParams();

    useEffect(()=>{
        getExhibitionList()
    }, [tag]);

    useEffect(()=>{
        allTagStateChange()
    }, []);

    const image_in_list = `${process.env.PUBLIC_URL}/project_exhibition.jpg`


    const allTagStateChange =()=>{
        setTagFreeAdmission(false);
        setTagRecoomendation(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(true);
    }

    const photographTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(true);
        setTagAll(false);
    }

    const appliedFineArtsTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(true);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const ancientArtsTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(true);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const classicArtTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(true);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const modernArtTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(true);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const contemporaryArtTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(false);
        setTagContemporaryArt(true);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const freeAdmissionTagStateChange =()=>{
        setTagRecoomendation(false);
        setTagFreeAdmission(true);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    const recoomendationTagStateChange =()=>{
        setTagRecoomendation(true);
        setTagFreeAdmission(false);
        setTagContemporaryArt(false);
        setTagModernArt(false);
        setTagClassicArt(false);
        setTagAncientArt(false);
        setTagAppliedFineArts(false);
        setTagPhotograph(false);
        setTagAll(false);
    }

    function getExhibitionList(){
        axios.get('/api/upcoming_exhibition_list/'+tag)
        .then(exhibitionListFromMongo=>{
            setExhibitions(exhibitionListFromMongo.data)
            setExhibitionsNumber(exhibitionListFromMongo.data.length)
        })
        .catch(error=>{
            console.log(error)
        })
    };

const all = 
    (tag=='all')?<div>
    <p className='result_number'>All Exhibitions / {exhibitionsNumber} Exhibitions</p>
    </div>:'';

const photograph = 
    (tag=='photograph')?<div>
    <p className='result_number'>Photograph / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const applied_fine_arts = 
    (tag=='applied_fine_arts')?<div>
    <p className='result_number'>Applied Fine Arts / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const ancient_art = 
    (tag=='ancient_art')?<div>
    <p className='result_number'>Ancient Art / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const classic_art = 
    (tag=='classic_art')?<div>
    <p className='result_number'>Classic Art / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const modern_art = 
    (tag=='modern_art')?<div>
    <p className='result_number'>Modern Art / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const contemporary_art = 
    (tag=='contemporary_art')?<div>
    <p className='result_number'>Contemporary Art / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const isFreeAdmission = 
    (tag=='isFreeAdmission')?<div>
    <p className='result_number'>Free Admission / {exhibitionsNumber}  Exhibitions</p>
    </div>:'';

const isRecommendation = 
    (tag=='isRecommendation')?<div>
    <p className='result_number'>Recommendation / {exhibitionsNumber}  Exhibitions </p>
    </div>:'';

    return(
        <div className='exhibitionList'>
            <div className='current_upcoming_in_exhibiton_flex'>
            <Link to='/exhibitions/current/list/all'><p className='current_in_upcoming_exhibition'>Current Exhibitions</p></Link>
            <p className='upcoming_in_upcoming_exhibition'>Upcoming Exhibitions</p>
            </div>
            
            <div className='exhibition_tag_group'>
               <Link to='/exhibitions/upcoming/list/isFreeAdmission'  onClick={ freeAdmissionTagStateChange } className={`tag_event ${tagFreeAdmission? "highlight_tag" :"normal_tag"}`}>Free Admission</Link>
               <Link to='/exhibitions/upcoming/list/isRecommendation'  onClick={ recoomendationTagStateChange} className={`tag_event ${tagRecommendation? "highlight_tag" :"normal_tag"}`}>Recommendation</Link>
               <Link to='/exhibitions/upcoming/list/contemporary_art' onClick={ contemporaryArtTagStateChange } className={`tag_event ${tagContemporaryArt? "highlight_tag" :"normal_tag"}`}>Contemporary Art</Link>
               <Link to='/exhibitions/upcoming/list/modern_art' onClick={ modernArtTagStateChange } className={`tag_event ${tagModernArt? "highlight_tag" :"normal_tag"}`}>Modern Art</Link>
               <Link to='/exhibitions/upcoming/list/classic_art' onClick={ classicArtTagStateChange } className={`tag_event ${tagClassicArt? "highlight_tag" :"normal_tag"}`}>Classic Art</Link>
               <Link to='/exhibitions/upcoming/list/ancient_art' onClick={ ancientArtsTagStateChange } className={`tag_event ${tagAncientArt? "highlight_tag" :"normal_tag"}`}>Ancient Art</Link>
               <Link to='/exhibitions/upcoming/list/applied_fine_arts' onClick={ appliedFineArtsTagStateChange } className={`tag_event ${tagAppliedFineArts? "highlight_tag" :"normal_tag"}`}>Applied Fine Arts</Link>
               <Link to='/exhibitions/upcoming/list/photograph' onClick={ photographTagStateChange } className={`tag_event ${tagPhotograph? "highlight_tag" :"normal_tag"}`}>Photograph</Link>
               <Link to='/exhibitions/upcoming/list/all' onClick={ allTagStateChange } className={`tag_event ${tagAll? "highlight_tag" :"normal_tag"}`}>All</Link>
               </div>

            <div>
               <div>{all}</div>
               <div>{photograph}</div>
               <div>{applied_fine_arts}</div>
               <div>{ancient_art}</div>
               <div>{classic_art}</div>
               <div>{modern_art}</div>
               <div>{contemporary_art}</div>
               <div>{isFreeAdmission}</div>
               <div>{isRecommendation}</div>
            </div>
                
            
            <ul className='exhibition_list'>
              {(exhibitions)?<div>
              {exhibitions.map((exhibition)=>
              <li key={exhibition._id}><Link to={`/exhibitions/upcoming/list/${tag}/detail/${exhibition._id}`}>
                   <div className='exhibition_list_img_wrapper'>
                   {/* <img src={exhibition.image}/> */}
                   <img src={exhibition.image==''? image_in_list:exhibition.image}/>
                   <h3>{exhibition.name}</h3>
                   <h5> / {exhibition.museum.name?  exhibition.museum.name: "" }</h5>
                   <h4>{exhibition.modifyOpnday + ' - ' + exhibition.modifyClsday}</h4>
                   <p>{exhibition.image_copyright}</p>
                   </div>
                  </Link>
                  </li>
                )}
               </div>:''}
             </ul>
         
        </div>
    )
}

export default ExhibitionUpcomingList;